module.exports = __webpack_public_path__ + "static/img/MA_1920_ru_awards4.3929db6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/MA_1920_ru_awards4.jpg
// module id = l5Kz
// module chunks = 1